import React from 'react';
import Img from 'img';
import Icon from 'icon';
import Headline from 'shared/headline';
import s from './infl-card.module.scss';

function InflCard({
  firstName,
  lastName,
  username,
  featuredImage,
  index,
  country,
  followers,
  ...props
}) {
  return (
    <>
      <div className={`${s.card} ${index === 0 && s.card1}`}>
        <a href={`/influencers/${username}`} className={s.imgWrapper}>
          <Img
            className={s.featuredImage}
            src={featuredImage}
            alt={featuredImage?.id}
          />
          {index === 0 && (
            <div className={s.labelWrapper}>
              <p
                className={s.top1}
                dangerouslySetInnerHTML={{ __html: '#1 TOP REQUEST' }}
              />
              {' '}
              <div className={s.triangle} />
              {' '}
            </div>
          )}
          {index === 1 && (
            <div className={s.labelWrapper}>
              <p
                className={s.top2}
                dangerouslySetInnerHTML={{ __html: '#2 TOP REQUEST' }}
              />
              {' '}
              <div className={`${s.triangle} ${s.grey}`} />
              {' '}
            </div>
          )}
          {index === 2 && (
            <div className={s.labelWrapper}>
              <p
                className={s.top3}
                dangerouslySetInnerHTML={{ __html: '#3 TOP REQUEST' }}
              />
              {' '}
              <div className={`${s.triangle} ${s.brown}`} />
              {' '}
            </div>
          )}
        </a>
        {(firstName || lastName) && (
          <Headline
            className={s.fullName}
            html={`${firstName.replace(
              firstName[0],
              firstName[0].toUpperCase()
            )} ${lastName.replace(lastName[0], lastName[0].toUpperCase())}`}
          />
        )}
        <div className={s.wrapper1}>
          {username && (
            <div className={`${s.flex} ${s.row} ${s.margin}`}>
              <Icon className={s.icon} icon="link-chain" />
              <a
                className={s.text}
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.instagram.com/${username}`}
                dangerouslySetInnerHTML={{ __html: `@${username}` }}
              />
            </div>
          )}
          {country?.name && (
            <div className={`${s.flex} ${s.row}`}>
              <Icon className={s.icon} icon="location-pin" />
              <p
                className={s.text}
                dangerouslySetInnerHTML={{ __html: country?.name }}
              />
            </div>
          )}
        </div>
        {index === 0 && (
          <p
            className={s.paragraph}
            dangerouslySetInnerHTML={{
              __html: `Know as @${username} on Instagram, artist ${firstName} ${lastName} was born in ${country?.name}.`
            }}
          />
        )}
      </div>
    </>
  );
}
export default InflCard;
